import { useState, useCallback } from "react";

const useCSVParser = () => {
  const [csvFile, setCSVFile] = useState(null);
  const [droneIds, setDroneIds] = useState([]);
  const [error, setError] = useState("");
  const handleFileChange = (e) => {
    setCSVFile(e.target.files[0]);
  };

  const parseCSV = useCallback(() => {
    if (!csvFile) {
      setError("Please choose a CSV file first.");
      return;
    }
    setError("");
    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const text = event.target.result;
        const rows = text.split("\n").map((row) => row.trim()).filter(Boolean);
        if (rows.length === 0) {
          setError("CSV file is empty.");
          return;
        }
        const headers = rows[0].split(",").map((h) => h.replace(/"/g, "").trim());
        const idIndex = headers.indexOf("ID");
        if (idIndex === -1) {
          setError(`No "ID" column found in CSV headers: [${headers.join(", ")}]`);
          return;
        }
        const ids = rows.slice(1).reduce((acc, row) => {
          const cols = row.split(",").map((col) => col.replace(/"/g, "").trim());
          const idValue = cols[idIndex];
          if (idValue) acc.push(idValue);
          return acc;
        }, []);
        setDroneIds(ids);
      } catch (err) {
        console.error(err);
        setError("Failed to parse CSV. Please check the file format.");
      }
    };
    reader.onerror = () => setError("Error reading the CSV file.");
    reader.readAsText(csvFile);
  }, [csvFile]);

  return { csvFile, droneIds, error, handleFileChange, parseCSV };
};

export default useCSVParser;
